import type { ErrorInfo, ReactNode } from 'react';
import * as React from 'react';

interface ErrorBoundaryState {
  hasError: boolean;
}

interface ErrorBoundaryProps {
  children: ReactNode;
  scope: string;
  fallback: ReactNode;
}

/**
 * TODO:
 * - Consider using https://www.npmjs.com/package/react-error-boundary
 */
export class NewRelicErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    if (!window.newrelic) return;

    window.newrelic.noticeError(error, { scope: this.props.scope, stack: info.componentStack ?? '' });
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return this.props.fallback;
    }

    return this.props.children;
  }
}
